import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M14.35 4.25c.735.19 1.426.48 2.065.857l.65-.65c.25-.25.589-.393.944-.393s.694.14.943.392l.943.944c.25.249.393.588.393.943s-.14.694-.393.943l-.65.651c.376.635.666 1.33.856 2.064h.918c.738 0 1.333.598 1.333 1.333v1.332c0 .738-.598 1.333-1.333 1.333h-.918a8 8 0 0 1-.856 2.064l.65.65c.25.25.393.589.393.944s-.14.694-.393.943l-.943.944c-.25.249-.588.392-.943.392s-.695-.14-.944-.392l-.65-.651a8 8 0 0 1-2.064.856v.919c0 .737-.598 1.332-1.333 1.332h-1.336a1.33 1.33 0 0 1-1.332-1.332v-.919a8 8 0 0 1-2.064-.856l-.65.65c-.25.25-.59.393-.944.393-.355 0-.695-.14-.944-.392l-.943-.944a1.34 1.34 0 0 1-.392-.943c0-.355.14-.694.392-.943l.65-.651a8 8 0 0 1-.855-2.064H3.68a1.33 1.33 0 0 1-1.332-1.333v-1.332c0-.738.597-1.333 1.332-1.333H4.6c.19-.734.479-1.426.856-2.064l-.651-.65a1.34 1.34 0 0 1-.392-.944c0-.355.14-.694.392-.943l.943-.944c.25-.249.589-.392.944-.392s.694.14.943.392l.65.651a8 8 0 0 1 2.065-.856v-.919c0-.737.598-1.332 1.332-1.332h1.333c.738 0 1.332.598 1.332 1.333v.918z"
    />
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={13.333}
      strokeWidth={1.2}
      d="M18.13 13.18c-1.002 1.36-4.626 1.145-4.268-1.408.177-1.276 1.531-1.295 2.054-1.015.744.396 1.065 1.295.77 2.086-.642 1.725-2.538 3.16-4.337 3.16-2.208 0-4.001-1.793-4.001-4 0-2.208 1.793-4.001 4-4.001"
      style={{
        stroke: "var(--icon-accent,#E47B53)",
      }}
    />
  </svg>
);
export const OptionIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
